  $(document).ready(function(){
     const productType = '{{ product.type | downcase }}';
const mapSize = {
    "XS": ["PETITE", 1],
    'S': ["PETITE", 1],
    "M": ["ONE SIZE", 2],
    "L": ["ONE SIZE", 2],
    "XL": ["PLUS", 3],
    "2XL": ["PLUS", 3],
    "3XL": ["PLUS2", 4]
};
let prioritlist = {
  sweetlegs: 'waist',
  sweettops: 'bust'
}     
let sizingChart = [
    {
        "Sizing": "XS",
        "Bust": "81-85",
        "Waist": "61-65",
        "Hip": "89-92"
    },
    {
        "Sizing": "S",
        "Bust": "86-90",
        "Waist": "66-70",
        "Hip": "93-98"
    },
    {
        "Sizing": "M",
        "Bust": "91-95",
        "Waist": "71-75",
        "Hip": "99-105"
    },
    {
        "Sizing": "L",
        "Bust": "96-105",
        "Waist": "76-87",
        "Hip": "106-115"
    },
    {
        "Sizing": "XL",
        "Bust": "106-118",
        "Waist": "88-100",
        "Hip": "116-128"
    },
    {
        "Sizing": "2XL",
        "Bust": "119-128",
        "Waist": "101-113",
        "Hip": "129-141"
    },
    {
        "Sizing": "3XL",
        "Bust": "129-137",
        "Waist": "114-122",
        "Hip": "142-150"
    }
];
 if($('.sizing-option').hasClass('size-Petite'))   {
     $.each(sizingChart, function(index, size) {
               test = size['Sizing']
            size['Sizing'] = mapSize[test][0]
        });

   console.log('thsi hit', sizingChart)
 } else if($('.sizing-option').hasClass('size-1'))   {
     $.each(sizingChart, function(index, size) {
               test = size['Sizing']
            size['Sizing'] = mapSize[test][1]
        });

   console.log('thsi hit', sizingChart)
 }
function getSizing(bust, waist, hip) {
    let bustSize, waistSize, hipSize;
    
    for (const size of sizingChart) {
        const [bustMin, bustMax] = size.Bust.split('-').map(Number);
        const [waistMin, waistMax] = size.Waist.split('-').map(Number);
        const [hipMin, hipMax] = size.Hip.split('-').map(Number);

        if (bust >= bustMin && bust <= bustMax) {
            bustSize = size["Sizing"];
        }
        if (waist >= waistMin && waist <= waistMax) {
            waistSize = size["Sizing"];
        }
        if (hip >= hipMin && hip <= hipMax) {
            hipSize = size["Sizing"];
        }
    }

    if (bustSize === waistSize && waistSize === hipSize) {
        return bustSize;
    } else {
        const sizes = [bustSize, waistSize, hipSize].filter(Boolean);
        const sizeRanks = sizingChart.map(size => size["Sizing"]);
        
        const suggestedSize = sizes.reduce((largest, current) => {
            return size =  sizeRanks.indexOf(current) > sizeRanks.indexOf(largest) ? current : largest;
        });
        if(productType.includes('sweetlegs')) {
          return hipSize;
        } else if(productType.includes('sweettops')) {
                return bustSize;
        } else {
            return suggestedSize;
        }
    }
}
       document.getElementById('recommend_size').addEventListener('click', function(e) {
         e.preventDefault();
         $('.range_slider_container').addClass('hideMe')
         $('.recommended_result').removeClass('hideMe')
        if($('.cm.converter-slider').hasClass('active')) {
           bust = parseInt(document.getElementById('bust').value);
           waist = parseInt(document.getElementById('waist').value);
           hip = parseInt(document.getElementById('hip').value);
         } else {
           bust = parseInt(document.getElementById('bust').value) * 2.54;
           waist = parseInt(document.getElementById('waist').value) * 2.54;
           hip = parseInt(document.getElementById('hip').value) * 2.54;
         }
            
            // Use the values of bust, waist, and hip to calculate the size
            const result = getSizing(bust, waist, hip);
           $('#recommendedsizeText').html(result)
  
            // For demonstration purposes, let's just alert the values
        });
        $('#edit_size').click(function(e) {
            e.preventDefault();
            $('.range_slider_container').removeClass('hideMe')
            $('.recommended_result').addClass('hideMe')
        })

     
          $(".converter").click(function() {
                // Remove 'active' class from all buttons and add it to the clicked button
                $(".converter").removeClass('active');
                $(this).addClass('active');

                var contentToShow, contentToHide;
                
                if ($(this).hasClass('inches')) {
                    contentToShow = $(".measurements-table.sizing_inches");
                    contentToHide = $(".measurements-table.sizing_cm");
                } else {
                    contentToShow = $(".measurements-table.sizing_cm");
                    contentToHide = $(".measurements-table.sizing_inches");
                }

                // Hide the content that should be hidden
                contentToHide.fadeOut(400, function() {
                    contentToHide.slideUp(400, function() {
                        // Show the content that should be shown
                        contentToShow.slideDown(400, function() {
                            contentToShow.fadeIn(400);
                        });
                    });
                });
            });
        });


            $(".converter-slider").click(function() {
                // Remove 'active' class from all buttons and add it to the clicked button
                $(".converter-slider").removeClass('active');
              $('.flip-card-front').toggleClass('flip');
                $(this).addClass('active');
              if($(this).hasClass('cm')) {
                var conversionFactor = 2.54;
              } else {
                 var conversionFactor = 1/2.54;
              }
              var $bustSlider = $('.range-slider__range');
               $('.range-slider__range').each(function() {
                  var $bustSlider =  $(this);

                // Current values in inches
                var valueInInches = Math.round($bustSlider.val());
                var valueInIncheValue =     Math.round($(this).parent().find('.range-slider__value').html())
                var minInInches = Math.round($bustSlider.attr('min'));
                var maxInInches = Math.round($bustSlider.attr('max'));

                // Conversion factor from inches to centimeters
  
   
                // Convert values to centimeters
                var valueInCm =  Math.round(valueInInches * conversionFactor);
                var valueInCmValue =  Math.round(valueInIncheValue * conversionFactor);
                var minInCm =  Math.round(minInInches * conversionFactor);
                var maxInCm =  Math.round(maxInInches * conversionFactor);
              
             $(this).parent().find('.range-slider__value').html(valueInCmValue)

                // Update the range slider attributes

                $bustSlider.attr('min', minInCm);
                 
                $bustSlider.attr('max', maxInCm);
                 $bustSlider.val(valueInCm);
               })
   
            });

   $('.range-slider__range').on('input change', function() {
    // Get the new value of the range input
    var newValue = $(this).val();
    
    // Update the span with the new value
    $(this).parent().find('.range-slider__value').text(newValue);
    
    // Assuming `value_in_inches` is a variable you want to update
    // You can declare this variable in the script scope if needed
    var value_in_inches = newValue;

    // For demonstration purposes, let's log the value
    console.log('Value in inches: ' + value_in_inches);

    // If you have an element to show value_in_inches, you can update it like this
    // $('#valueInInches').text(value_in_inches);
  });
